'use client'
import { FC, useState, useEffect } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";
import Link from 'next/link'
import styles from './NetworkStatus.module.css'

/**
 * Props for `NetworkStatus`.
 */
export type NetworkStatusProps =
  SliceComponentProps<Content.NetworkStatusSlice>;

/**
 * Component for "NetworkStatus" Slices.
 */
const NetworkStatus: FC<NetworkStatusProps> = ({ slice }) => {

  const [statusData, setStatusData] = useState(null) as any

  useEffect(()=>{
  
  async function fetchData() {
      await fetch("/api/get-status-updates").then(res => res.json())
      .then(response => { 
          // console.log(response.data); 
          setStatusData(response.data) } )
      .catch(error => console.error('Error:', error));
      }
  fetchData();

  },[])

  if(statusData) {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="w-full font-fellix text-jade bg-[#f5f5f5] pb-24" 
    >
      <div className="px-4 md:px-8 lg:px-12 pt-24 text-center">
      <article className="text-[64px] leading-[60px] font-normal mb-12">
        <PrismicRichText field={slice.primary.title}/>
      </article>
      <article className="text-[28px] leading-[36px] font-normal">
        <PrismicRichText field={slice.primary.paragraph}/>
      </article>
      <PrismicNextImage field={slice.primary.image} fallbackAlt="" className="mt-18 w-[260px] h-[260px] mx-auto"/>
      </div>
      <div className={`${styles.root} px-4 md:px-8 lg:px-12 overflow-x-scroll`}>
          <div className={styles.innerWrapper}>
            <h3 className="pb-4" dangerouslySetInnerHTML={{__html: statusData.state}}/>
            <div dangerouslySetInnerHTML={{__html: statusData.data}}/>
            <div className={styles.subscribeNetwork}>
            <Link href="https://ultrafastfibre.statuspage.io/">
                View details and subscribe to updates &gt;
            </Link>
            </div>
          </div>
      </div>
    </section>
  )
  }
};

export default NetworkStatus;
